import React from 'react';
import {canonical} from "../../libs/helper";
import { Link } from "react-router-dom";

class Breadcrumbs extends React.Component {
     /*constructor(props) {
         super(props);
         /*this.state = {
             isHomeAdd : false
         }*/
     //}


    componentWillUnmount()
    {
        if (document.getElementById("breadcrumbList")) {
            document.getElementById("breadcrumbList").remove();
        }
    }

    render() {
        let isHome = this.props.isHome || true;
        let data = this.props.data || [];

        if (isHome) {
            data = data.filter(item => item.name !== "Accueil");
            data.unshift({
                name: "Accueil",
                link: canonical("", "", "home"),
                to: "/"
            });
        }

        let jsonData = [];


        data.forEach((item, index) => {
            jsonData.push(
                {
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": item.name,
                    "item": item.link
                }
            );
        });
        if (jsonData) {
            let script = document.createElement("script");
            if (document.getElementById("breadcrumbList")) {
                script = document.getElementById("breadcrumbList");
            }
            script.type = "application/ld+json";
            script.id = "breadcrumbList";
            script.innerHTML = `{
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": ${JSON.stringify(jsonData)}
        }`;
            document.getElementsByTagName('head')[0].appendChild(script);
        } else {
            document.getElementById("breadcrumbList").remove();
        }

        let nbLink = data.length - 1;

        return (
            <ul id={"breadcrumbs"}>
                {data.map((item, index) => {
                    let relLink = item.relLink || {};
                    return nbLink === index ? <li key={`bread${index}`}>{item.name}</li> :
                        <li key={`bread${index}`}><Link to={item.to} {...relLink} title={item.name}>{item.name}</Link></li>
                })}
            </ul>
        )
    }
};

export default Breadcrumbs;